export enum PageSource {
  Download = "download",
  Signin = "signin",
  Signup = "signup",
  SSOCallback = "sso-callback",
  UpdateMac = "update-mac",
  Pricing = "pricing",
  AppAuth = "app-auth",
  AuthHandoff = "auth-handoff",
}
